export enum InternalErrorType {
  NotFound = 'not-found',
  ServiceError = 'service-error',
  Maintenance = 'maintenance',
}
